import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, Box, Container, CssBaseline } from '@mui/material';
import { AuthProvider } from './contexts/AuthContext';
import { UserTypeProvider } from './contexts/UserTypeContext';
import LoginPage from './pages/auth/LoginPage';
import SignupPage from './pages/auth/SignupPage';
import KakaoAuthHandler from './pages/auth/KakaoAuthHandler';
import MyPage from './pages/mypage/MyPage';
import ReviewerMyPage from './pages/mypage/ReviewerMyPage';
import AdvertiserMyPage from './pages/mypage/AdvertiserMyPage';
import AdvertiserEditProfilePage from './pages/mypage/AdvertiserEditProfilePage';
import ReviewerEditProfilePage from './pages/mypage/ReviewerEditProfilePage';
import SettingsPage from './pages/mypage/SettingsPage';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import GuidePage from './pages/GuidePage';
import Header from './components/Header';
import BottomNavigation from './components/BottomNavigation';
import CampaignListPage from './pages/CampaignListPage';
import CampaignDetailPage from './pages/CampaignDetailPage';
import ReviewWritePage from './pages/ReviewWritePage';

// 리뷰어 관련 페이지들
import ReviewerCampaignApplicationsPage from './pages/mypage/ReviewerCampaignApplicationsPage';
import ReviewerLikedCampaignsPage from './pages/mypage/ReviewerLikedCampaignsPage';
import ReviewerPenaltyPage from './pages/mypage/ReviewerPenaltyPage';

// 광고주 관련 페이지들
import AdvertiserCampaignsPage from './pages/mypage/AdvertiserCampaignsPage';
import CampaignCreatePage from './pages/mypage/CampaignCreatePage';

// 공통 페이지들
import NoticePage from './pages/mypage/NoticePage';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1a237e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <UserTypeProvider>
            <Box sx={{ 
              minHeight: '100vh',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <Header />
              <Box 
                component="main" 
                sx={{ 
                  flex: 1,
                  mt: '56px', // Fixed header height
                  '@media (min-width: 600px)': {
                    mt: '64px', // Taller header on larger screens
                  },
                  pb: '64px', // Bottom navigation height
                }}
              >
                <Container 
                  maxWidth="md" 
                  disableGutters 
                  sx={{ 
                    px: { xs: 1.5, sm: 3 },
                    py: { xs: 1.5, sm: 2 }
                  }}
                >
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/category" element={<CategoryPage />} />
                    <Route path="/category/:category" element={<CategoryPage />} />
                    <Route path="/guide" element={<GuidePage />} />
                    <Route path="/mypage" element={<MyPage />} />
                    <Route path="/mypage/reviewer" element={<ReviewerMyPage />} />
                    <Route path="/mypage/advertiser" element={<AdvertiserMyPage />} />
                    <Route path="/mypage/advertiser/edit-profile" element={<AdvertiserEditProfilePage />} />
                    <Route path="/mypage/reviewer/edit-profile" element={<ReviewerEditProfilePage />} />
                    <Route path="/mypage/settings" element={<SettingsPage />} />
                    
                    {/* 리뷰어 관련 페이지들 */}
                    <Route path="/mypage/reviewer/campaign-applications" element={<ReviewerCampaignApplicationsPage />} />
                    <Route path="/mypage/reviewer/liked-campaigns" element={<ReviewerLikedCampaignsPage />} />
                    <Route path="/mypage/reviewer/penalty" element={<ReviewerPenaltyPage />} />
                    
                    {/* 광고주 관련 페이지들 */}
                    <Route path="/mypage/advertiser/campaigns" element={<AdvertiserCampaignsPage />} />
                    <Route path="/campaign/create" element={<CampaignCreatePage />} />
                    
                    {/* 공통 페이지들 */}
                    <Route path="/mypage/notice" element={<NoticePage />} />
                    
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/campaigns" element={<CampaignListPage />} />
                    <Route path="/campaign/:campaignId" element={<CampaignDetailPage />} />
                    <Route path="/review/write" element={<ReviewWritePage />} />
                    <Route path="/auth/kakao/callback" element={<KakaoAuthHandler />} />
                  </Routes>
                </Container>
              </Box>
              <BottomNavigation />
            </Box>
          </UserTypeProvider>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
